
import * as marietta from '../../..';

export class BuildingDocument {

    public docList = [];

    constructor() {
        ;
    }

    public async execute(): Promise<any> {
        
        // ドキュメント取得
        const url = marietta.webcad.WebCADGlobal.webcad2Dmanager.get_document_api_url;
        const token = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.access_token}`;

        const response = await fetch(url, {
            method: 'GET',
            headers: {
                Authorization: token,
            },
        });        
        const data = await response.json();
        this.docList = data.article_documents;
        return data;

    }

} 